import { render, staticRenderFns } from "./BuyBoxNoOfferRow.vue?vue&type=template&id=6a82e3f2&scoped=true"
import script from "./BuyBoxNoOfferRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxNoOfferRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxNoOfferRow.vue?vue&type=style&index=0&id=6a82e3f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a82e3f2",
  null
  
)

export default component.exports